import React from 'react'
import { string } from 'prop-types'

/**
 * Server component that renders navigation link with given href and text
 * @param {String} href - URL to navigate to
 * @param {String} text - Text to display
 */

function Link({ href, text }) {
  return (
    <a
      className="cgt-menu-item cgt-menu-item--medium"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
    </a>
  )
}

Link.propTypes = {
  href: string.isRequired,
  text: string.isRequired,
}

export default Link
